import { render, staticRenderFns } from "./Recursos.vue?vue&type=template&id=2686a00d"
import script from "./Recursos.vue?vue&type=script&lang=js"
export * from "./Recursos.vue?vue&type=script&lang=js"
import style0 from "./Recursos.vue?vue&type=style&index=0&id=2686a00d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports